import lang from '../../lib/language';

import ArrowPositiveGrowth from '../../assets/img/icon_arrow_positive_growth.png';
import IconInfinity from '../../assets/img/icon_infinity.png';
import IconMetrics from '../../assets/img/icon_metrics.png';

type OptionType = {
  title: string;
  description: string;
  icon: string;
}

export const getCarouselOptions = (): OptionType[] => {
  const options: OptionType[] = [];
  options.push({
    title: lang.hammerLoginTitle1(),
    description: lang.hammerLoginDescription1(),
    icon: IconMetrics,
  });

  options.push({
    title: lang.hammerLoginTitle2(),
    description: lang.hammerLoginDescription2(),
    icon: IconInfinity,
  });

  options.push({
    title: lang.hammerLoginTitle3(),
    description: lang.hammerLoginDescription3(),
    icon: ArrowPositiveGrowth,
  });

  return options;
};
